import { CommonRouter } from '@primeit/components-vue';

CommonRouter.registerRoutes([{
  alias: '/u/:id',
  children: [
    {
      component: () => import(/* webpackChunkName: "app.uploadfiles" */ './UploadFiles.vue'),
      meta: {
        label: 'upload.title',
        secure: false,
      },
      path: '',
      props: true,
    },
  ],
  component: () => import(/* webpackChunkName: "app.uploadfiles" */ '../common/person/CommonFullLayout.vue'),
  meta: {
    secure: false,
    visible: false,
  },
  path: '/upload/:id',
  props: true,
}]);
